import { Typography } from '@mui/material';
import { useSuspense } from 'rest-hooks';
import { useApplication } from '../../../model/context/applicationContext';
import { VariableResultPreview } from '../../../model/entities/variableResultPreview';
import { Variable } from '../../../model/interfaces/variable';

interface VariableTestResultProps {
  variable: Variable;
  isOpen: boolean;
}

export const FetchVariableTestResult = (props: VariableTestResultProps) => {
    const { variable, isOpen } = props;
    const { applicationNumber, applicationXml } = useApplication();
    const testResult = useSuspense(
        VariableResultPreview,
        isOpen && variable.variableId && applicationNumber && applicationXml
            ? {
                variableId: variable.variableId,
                applicationNumber: applicationNumber,
                applicationXml: applicationXml
            }
            : null
    );
    return  testResult?.result;
};

export const VariableTestResult = (props: VariableTestResultProps) => {

    const testResult = FetchVariableTestResult( props);

  return <Typography>Result: {testResult}</Typography>;
};
